import request from '@/util/request'
import { isArray, isPlainObject, isString, forEach } from 'lodash'

function _removeSpecialCharacter(data) {
  if (!isArray(data) && !isPlainObject(data)) {
    return data
  }
  forEach(data, (value, key) => {
    if (isPlainObject(value) || isArray(value)) {
      _removeSpecialCharacter(value)
      return
    }
    if (isString(value) && value.includes(`¶`)) {
      const index = value.indexOf(`¶`)
      data[key] = data[key].slice(0, index)
    }
  })
  return data
}

export function http({ path, data, method }) {
  let dataProp = 'data'
  // post -> data
  // get -> params
  if (method.toLocaleLowerCase() === 'get') {
    dataProp = 'params'
  }

  return request({
    url: path,
    [dataProp]: _removeSpecialCharacter(data),
    method
  })
}

